export const restrictedResourcesForUser = ['/onboarding'];